import { createContext } from 'react';

export const CurrentBookingContext = createContext<
  { bookingId: string; hotelReferenceId: string } | undefined
>(undefined);
